import { InjectionToken } from '@angular/core';

/**
 * Registers a worker implementation, generated by Angular CLI and implemented according documentation
 *
 * Example:
 *
 * ```
 * providers: [
 *   { provide: GRPC_WORKER, useFactory: () => new Worker('./grpc.worker', { type: 'module' }) },
 * ]
 * ```
 */
export const GRPC_WORKER = new InjectionToken<Worker>('GRPC_WORKER');

/**
 * Default configuration for grpc-web clients running in worker. Will be used for every GrpcWorkerClient unless service-specific config is provided
 *
 * Example:
 *
 * ```
 * providers: [
 *   { provide: GRPC_WORKER_CLIENT_DEFAULT_SETTINGS, useClass: { host: 'localhost:4321' } },
 * ]
 * ```
 */
export const GRPC_WORKER_CLIENT_DEFAULT_SETTINGS = new InjectionToken('GRPC_WORKER_CLIENT_DEFAULT_SETTINGS');
